import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Typography,
  Paper,
  Button,
  Box,
  Chip
} from '@mui/material';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import axios from 'axios';
import dayjs from 'dayjs';
import { useTheme } from '@mui/material';
import Spinner from '../components/Spinner';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

const HistoriasDeHoy = () => {
  // Removed unused state 'endDate' and its setter 'setEndDate'
  const [results, setResults] = useState([]);
  const [stats, setStats] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [paginationModel, setPaginationModel] = useState({
    pageSize: 5,
    page: 0,
  });
  const navigate = useNavigate();
  const theme = useTheme();

  const columns = [
    { field: 'nombre', headerName: 'Nombre', flex: 1, minWidth: 200 },
    { field: 'numid', headerName: 'Identificación', width: 150 },
    { 
      field: 'birthdate', 
      headerName: 'Nacimiento', 
      width: 110,
      valueFormatter: (params) => {
        if (!params.value) return '';
        return dayjs(params.value).format('YYYY-MM-DD');
      }
    },
    { field: 'sexo', headerName: 'Sexo', width: 80 },
    { field: 'edocivil', headerName: 'Estado Civil', flex: 1, minWidth: 120 },
    { field: 'domicilio', headerName: 'Domicilio', flex: 2, minWidth: 200 },

  ];

  const fetchTodayPatients = useCallback(async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${API_URL}/api/pacientes-historias-hoy`);
      const todayPatientsWithIds = response.data.map((patient, index) => ({
        ...patient,
        id: patient.idpac || `today-temp-${index}`,
      }));
      
      setResults(todayPatientsWithIds);
      setStats(todayPatientsWithIds.length);
    } catch (error) {
      console.error('Error al obtener los pacientes con historias creadas hoy:', error);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchTodayPatients();
  }, [fetchTodayPatients]);

  const handleRowClick = (params) => {
    if (params.field !== 'actions') {
      navigate(`/historias/${params.row.idpac}`);
    }
  };

  return (
    <Box sx={{ 
      display: 'flex',
      padding: { xs: 1, sm: 2 },
      overflowY: 'auto',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      flexDirection: 'column' 
    }}>
      
      <Paper
        elevation={3}
        sx={{
          padding: { xs: 2, sm: 4 },
          width: '100%',
          maxWidth: '98vw',
          overflowX: 'auto',
          borderRadius: 2,
          height: 'auto',
          margin: 'auto',
          boxSizing: 'border-box',
          background: `linear-gradient(135deg, ${theme.palette.background.default} 0%,rgb(238, 245, 178) 100%)`,
          boxShadow: '0 8px 32px rgba(0,0,0,0.1)'
        }}>
        
        <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold', color: theme.palette.primary.main }}>
          Historias de Hoy ({stats} registros)
        </Typography>

        <Spinner isLoading={isLoading} message="Cargando pacientes..." />

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 4 }}>
          <Button 
            variant="contained" 
            onClick={fetchTodayPatients}
            sx={{ width: { xs: '100%', sm: 'auto' } }}
          >
            Actualizar
          </Button>

          {stats > 0 && (
            <Chip 
              label={`${stats} pacientes con historias hoy`}
              color="primary"
              sx={{ 
                fontSize: '1rem',
                py: 2.5,
                px: 1,
                borderRadius: 2,
                fontWeight: 'bold',
                background: `linear-gradient(45deg, ${theme.palette.primary.main} 30%, ${theme.palette.primary.light} 90%)`,
                boxShadow: '0 3px 5px 2px rgba(33, 150, 243, .3)'
              }}
            />
          )}
        </Box>

        <div style={{ height: '60vh', width: '100%', minHeight: '300px' }}>
          <DataGrid
            rows={results}
            columns={columns}
            paginationModel={paginationModel}
            onPaginationModelChange={setPaginationModel}
            pageSizeOptions={[5, 10, 25, 50]}
            onRowClick={handleRowClick}
            components={{ Toolbar: GridToolbar }}
            sx={{
              '& .MuiDataGrid-cell': {
                cursor: 'pointer'
              }
            }}
          />
        </div>
      </Paper>
    </Box>
  );
};

export default HistoriasDeHoy;